/*
  PawsLife "Weitermachen, wo du aufgehoert hast"
  ----------------------------------------------
  Wer einen Konfigurator mit 5-9 Schritten abbricht, faengt beim naechsten
  Besuch normalerweise bei null an. Dieses Modul merkt sich den Stand 7 Tage
  lang im localStorage des Kunden (nichts wird an einen Server geschickt) und
  bietet ihn beim naechsten Aufruf derselben Produktseite zur Wiederaufnahme an.

  Zwei Ausbaustufen, weil die Konfiguratoren unterschiedlich sind:
  - eigener Wizard: wir speichern und setzen die Feldwerte selbst.
  - TeeInBlue: die App stellt ihre Konfiguration selbst wieder her
    (localStorage "teeinblue-customizations"). Wir speichern nur, WO der Kunde
    war, und zeigen den Hinweis - sonst merkt er die Wiederherstellung nicht.

  Uploads werden nie gespeichert (Dateien lassen sich nicht zurueckschreiben).
*/
(function () {
  'use strict';

  if (window.pawsResume) return;

  var GUELTIG_MS = 7 * 24 * 60 * 60 * 1000;

  var ctxEl = document.querySelector('script[type="application/json"][data-paws-track]');
  var ctx = {};
  try { ctx = ctxEl ? JSON.parse(ctxEl.textContent) : {}; } catch (e) { ctx = {}; }

  var istTib = !!ctx.isTib;
  var schluessel = 'paws-weiter-' + (ctx.productHandle || window.location.pathname);

  var ls = null;
  try {
    window.localStorage.setItem('paws-weiter-test', '1');
    window.localStorage.removeItem('paws-weiter-test');
    ls = window.localStorage;
  } catch (e) { ls = null; }

  var konfig = null;          // Schnittstelle des eigenen Wizards
  var interagiert = false;    // erst nach echter Nutzereingabe speichern
  var nutzerAktiv = false;    // TeeInBlue: Formular wurde wirklich angefasst
  var bannerEl = null;
  var schreibTimer = null;

  /* ---------------------------------------------------------- Speicher */

  function standLesen() {
    if (!ls) return null;
    try {
      var roh = ls.getItem(schluessel);
      if (!roh) return null;
      var d = JSON.parse(roh);
      if (!d || d.handle !== (ctx.productHandle || null)) return null;
      if (!d.ts || Date.now() - d.ts > GUELTIG_MS) { ls.removeItem(schluessel); return null; }
      return d;
    } catch (e) { return null; }
  }

  function standSchreiben(daten) {
    if (!ls) return;
    try {
      daten.v = 1;
      daten.ts = Date.now();
      daten.handle = ctx.productHandle || null;
      daten.art = istTib ? 'teeinblue' : 'paws';
      var text = JSON.stringify(daten);
      // Ein einzelnes Produkt darf den Speicher des Kunden nicht fluten.
      if (text.length > 40000) return;
      ls.setItem(schluessel, text);
    } catch (e) {}
  }

  function standLoeschen() {
    if (!ls) return;
    try { ls.removeItem(schluessel); } catch (e) {}
  }

  // TeeInBlue legt seine Konfiguration selbst ab - ohne diesen Eintrag koennten
  // wir "weitermachen" anbieten, ohne dass irgendetwas wiederkaeme.
  function tibStandVorhanden() {
    if (!ls || !ctx.productId) return false;
    try {
      var liste = JSON.parse(ls.getItem('teeinblue-customizations') || '[]');
      if (!Array.isArray(liste)) return false;
      for (var i = 0; i < liste.length; i++) {
        var e = liste[i];
        if (!e || String(e.productId) !== String(ctx.productId)) continue;
        if (e.timestamp && Date.now() - e.timestamp > GUELTIG_MS) return false;
        return true;
      }
    } catch (e) {}
    return false;
  }

  function tibStandLoeschen() {
    if (!ls || !ctx.productId) return;
    try {
      var liste = JSON.parse(ls.getItem('teeinblue-customizations') || '[]');
      if (!Array.isArray(liste)) return;
      var rest = liste.filter(function (e) { return !e || String(e.productId) !== String(ctx.productId); });
      ls.setItem('teeinblue-customizations', JSON.stringify(rest));
    } catch (e) {}
  }

  /* ------------------------------------------------------------- Banner */

  function stilEinmal() {
    if (document.getElementById('paws-weiter-stil')) return;
    var s = document.createElement('style');
    s.id = 'paws-weiter-stil';
    s.textContent = [
      '.paws-weiter{display:flex;flex-wrap:wrap;align-items:center;gap:10px 14px;',
      'margin:0 0 16px;padding:12px 14px;border:1px solid #d9e2ec;border-radius:12px;',
      'background:#f6f9fc;color:#2b3644;font-size:14px;line-height:1.45}',
      '.paws-weiter__text{flex:1 1 220px;min-width:0}',
      '.paws-weiter__text b{display:block;font-weight:700}',
      '.paws-weiter__wo{color:#5b6878}',
      '.paws-weiter__aktionen{display:flex;align-items:center;gap:12px;flex-wrap:wrap}',
      '.paws-weiter__ja{border:0;border-radius:999px;padding:9px 18px;font:inherit;',
      'font-weight:700;color:#fff;background:#2b3644;cursor:pointer}',
      '.paws-weiter__ja:hover{background:#1c2531}',
      '.paws-weiter__nein{border:0;background:none;padding:6px 2px;font:inherit;',
      'color:#5b6878;text-decoration:underline;cursor:pointer}',
      '@media (max-width:520px){.paws-weiter__aktionen{width:100%}',
      '.paws-weiter__ja{flex:1 1 auto;text-align:center}}'
    ].join('');
    document.head.appendChild(s);
  }

  function bannerZiel() {
    if (istTib) {
      return document.querySelector('#teeinblue-form .tee-customize-main-form') ||
             document.getElementById('teeFormInputs');
    }
    return document.getElementById('paws-configurator-wrapper');
  }

  function bannerZeigen(stand, weiter) {
    var ziel = bannerZiel();
    // Ohne assets/paws-texte.js gaebe es nur ein Banner ohne Beschriftung.
    if (!ziel || bannerEl || typeof window.pawsText !== 'function') return false;
    stilEinmal();

    var box = document.createElement('div');
    box.className = 'paws-weiter';
    box.setAttribute('role', 'status');

    var text = document.createElement('div');
    text.className = 'paws-weiter__text';
    var titel = document.createElement('b');
    titel.textContent = window.pawsText('resume_title');
    text.appendChild(titel);
    if (stand.schrittName) {
      var wo = document.createElement('span');
      wo.className = 'paws-weiter__wo';
      // textContent: der Schrittname kommt aus fremdem Markup.
      wo.textContent = window.pawsText('resume_step', { step: stand.schritt, name: stand.schrittName });
      text.appendChild(wo);
    }
    box.appendChild(text);

    var aktionen = document.createElement('div');
    aktionen.className = 'paws-weiter__aktionen';

    var ja = document.createElement('button');
    ja.type = 'button';
    ja.className = 'paws-weiter__ja';
    ja.textContent = window.pawsText('resume_continue');
    ja.addEventListener('click', function () {
      bannerSchliessen();
      try { weiter(stand); } catch (e) {}
      melden('configurator_resume', stand, 'weiter');
    });

    var nein = document.createElement('button');
    nein.type = 'button';
    nein.className = 'paws-weiter__nein';
    nein.textContent = window.pawsText('resume_restart');
    nein.addEventListener('click', function () {
      melden('configurator_resume_discard', stand, 'neu');
      standLoeschen();
      if (istTib) {
        tibStandLoeschen();
        window.location.reload();
        return;
      }
      bannerSchliessen();
    });

    aktionen.appendChild(ja);
    aktionen.appendChild(nein);
    box.appendChild(aktionen);

    ziel.insertBefore(box, ziel.firstChild);
    bannerEl = box;
    melden('configurator_resume_offer', stand, 'angeboten');
    return true;
  }

  function bannerSchliessen() {
    if (bannerEl && bannerEl.parentNode) bannerEl.parentNode.removeChild(bannerEl);
    bannerEl = null;
  }

  function melden(name, stand, aktion) {
    try {
      var payload = {
        configurator: istTib ? 'teeinblue' : 'paws',
        step_index: stand.schritt || null,
        step_total: stand.schrittGesamt || null,
        step_name: stand.schrittName || '',
        resume_action: aktion,
        resume_age_hours: stand.ts ? Math.round((Date.now() - stand.ts) / 36000) / 100 : null
      };
      if (window.pawsInsights && window.pawsInsights.track) window.pawsInsights.track(name, payload);
      else (window.pawsInsightsQueue = window.pawsInsightsQueue || []).push([name, payload]);
    } catch (e) {}
  }

  /* ------------------------------------------------- eigener Konfigurator */

  function pawsSammeln() {
    var felder = konfig.felder();
    var liste = [];
    for (var i = 0; i < felder.length; i++) {
      var el = felder[i];
      if (!el.name) continue;
      var istWahl = el.type === 'radio' || el.type === 'checkbox';
      if (istWahl && !el.checked) continue;
      var wert = String(el.value == null ? '' : el.value).slice(0, 300);
      if (!istWahl && !wert) continue;
      liste.push({ n: el.name, v: wert, w: istWahl ? 1 : 0 });
      if (liste.length > 120) break;
    }
    return liste;
  }

  function pawsAnwenden(stand) {
    if (!konfig || !Array.isArray(stand.felder)) return;
    window.pawsWiederherstellung = true;
    try {
      var felder = konfig.felder();
      stand.felder.forEach(function (eintrag) {
        for (var i = 0; i < felder.length; i++) {
          var el = felder[i];
          if (el.name !== eintrag.n) continue;
          if (eintrag.w) {
            if (el.value !== eintrag.v) continue;
            if (!el.checked) { el.checked = true; feuern(el); }
          } else if (el.value !== eintrag.v) {
            el.value = eintrag.v;
            el.dispatchEvent(new Event('input', { bubbles: true }));
            feuern(el);
          }
          break;
        }
      });
      if (konfig.upsellsSetzen) konfig.upsellsSetzen(stand.upsells || []);
    } catch (e) {}
    window.pawsWiederherstellung = false;
    try { konfig.geheZu(stand.schritt ? stand.schritt - 1 : 0); } catch (e) {}
  }

  function feuern(el) {
    try { el.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
  }

  // Fotos kann niemand wiederherstellen. Wer schon weiter war, landet deshalb
  // auf dem Schritt mit dem fehlenden Bild statt hinter ihm auf einer
  // Zusammenfassung ohne Bild und Namen.
  function pawsZielBegrenzen(stand) {
    try {
      var grenze = konfig.grenzeIndex ? konfig.grenzeIndex() : -1;
      if (grenze >= 0 && (stand.schritt || 1) - 1 > grenze) {
        stand.schritt = grenze + 1;
        stand.schrittName = konfig.schrittName(grenze);
      }
    } catch (e) {}
    return stand;
  }

  function pawsMerken() {
    if (!konfig || !interagiert) return;
    if (schreibTimer) return;
    schreibTimer = setTimeout(function () {
      schreibTimer = null;
      try {
        var idx = konfig.schrittIndex();
        standSchreiben({
          schritt: idx + 1,
          schrittGesamt: konfig.schrittAnzahl(),
          schrittName: konfig.schrittName(idx),
          felder: pawsSammeln(),
          upsells: konfig.upsells ? konfig.upsells() : []
        });
      } catch (e) {}
    }, 500);
  }

  function pawsStart() {
    konfig = window.pawsKonfigurator;
    if (!konfig) return false;

    var angebot = null;
    var stand = standLesen();
    if (stand && stand.felder && stand.felder.length) {
      angebot = pawsZielBegrenzen(stand);
      bannerZeigen(angebot, pawsAnwenden);
    }

    // Wer selbst weiterkonfiguriert, hat sich gegen das Fortsetzen entschieden.
    // Bliebe das Banner stehen, wuerde ein spaeterer Klick darauf die frische
    // Auswahl mit dem alten Stand ueberschreiben.
    function angebotVerfaellt(e) {
      if (!bannerEl || !e.isTrusted || window.pawsWiederherstellung) return;
      if (bannerEl.contains(e.target)) return;
      bannerSchliessen();
      if (angebot) melden('configurator_resume_ignore', angebot, 'ignoriert');
    }

    var wrapper = document.getElementById('paws-configurator-wrapper');
    if (wrapper) {
      ['pointerdown', 'keydown'].forEach(function (typ) {
        wrapper.addEventListener(typ, angebotVerfaellt, true);
      });
      ['change', 'input'].forEach(function (typ) {
        wrapper.addEventListener(typ, function (e) {
          if (!e.isTrusted || window.pawsWiederherstellung) return;
          angebotVerfaellt(e);
          interagiert = true;
          pawsMerken();
        }, true);
      });
    }
    // Schrittwechsel passieren auch ohne Eingabe (Weiter/Zurueck).
    var letzterIdx = -1;
    setInterval(function () {
      try {
        if (!interagiert) return;
        var idx = konfig.schrittIndex();
        if (idx === letzterIdx) return;
        letzterIdx = idx;
        pawsMerken();
      } catch (e) {}
    }, 1000);
    return true;
  }

  /* ------------------------------------------------------------ TeeInBlue */

  function tibSchritte() {
    try {
      return (window.pawsInsights && window.pawsInsights.tibSchritte) ? window.pawsInsights.tibSchritte() : [];
    } catch (e) { return []; }
  }

  function tibWeiter(stand) {
    var liste = tibSchritte();
    var ziel = liste[(stand.schritt || 1) - 1];
    if (!ziel || !ziel.el) return;
    try {
      var oben = (window.pawsStickyTopOffset ? window.pawsStickyTopOffset() : 0) || 0;
      var y = ziel.el.getBoundingClientRect().top + window.pageYOffset - oben - 16;
      window.scrollTo({ top: y, behavior: 'smooth' });
    } catch (e) {}
  }

  function tibMerken(el) {
    if (schreibTimer) return;
    schreibTimer = setTimeout(function () {
      schreibTimer = null;
      try {
        var pos = (window.pawsInsights && window.pawsInsights.tibSchrittZu) ? window.pawsInsights.tibSchrittZu(el) : null;
        var liste = tibSchritte();
        standSchreiben({
          schritt: (pos && pos.index) || 1,
          schrittGesamt: liste.length || null,
          schrittName: (pos && pos.name) || ''
        });
      } catch (e) {}
    }, 600);
  }

  function tibStart() {
    var form = document.getElementById('teeinblue-form');
    if (!form || !bannerZiel()) return false;

    // Gelauscht wird nicht selbst: TeeInBlue setzt Kachelauswahlen ohne
    // change-Ereignis. assets/paws-insights.js kennt beide Wege und meldet
    // jede erkannte Auswahl ueber window.pawsResume.notiz().
    // Gespeichert wird aber erst, wenn jemand das Formular wirklich angefasst
    // hat - sonst legt schon das Aufbauen der Felder einen Stand an.
    ['pointerdown', 'keydown'].forEach(function (art) {
      form.addEventListener(art, function (e) { if (e.isTrusted) nutzerAktiv = true; }, true);
    });

    var stand = standLesen();
    // Ohne die Daten von TeeInBlue waere "Weitermachen" ein leeres Versprechen.
    if (stand && tibStandVorhanden()) {
      // Die Schrittliste steht erst, wenn TeeInBlue fertig gerendert hat.
      var versuche = 0;
      var t = setInterval(function () {
        versuche++;
        if (interagiert || versuche > 40) { clearInterval(t); return; }
        if (!tibSchritte().length) return;
        clearInterval(t);
        bannerZeigen(stand, tibWeiter);
      }, 400);
    }
    return true;
  }

  /* ----------------------------------------------------------------- Start */

  window.pawsResume = {
    ready: true,
    // Wird von assets/paws-insights.js bei jeder erkannten Auswahl gerufen.
    notiz: function (el) {
      if (!istTib || !nutzerAktiv || window.pawsWiederherstellung) return;
      interagiert = true;
      bannerSchliessen();
      tibMerken(el);
    },
    // Nach einem erfolgreichen Warenkorb-Zulegen gibt es nichts mehr fortzusetzen.
    fertig: function () {
      standLoeschen();
      if (istTib) tibStandLoeschen();
      bannerSchliessen();
    }
  };

  function init() {
    try {
      if (!ls) return;
      // TeeInBlue stellt die Konfiguration beim Neuladen selbst wieder her -
      // ein zweiter Hinweis mitten im Konfigurator verwirrt nur.
      if (istTib) { standLoeschen(); return; }
      // Variante B zeigt alle Schritte gleichzeitig. Ein Banner "Du hattest
      // hier schon angefangen" ueber einer Seite, auf der die getroffene Wahl
      // ohnehin komplett sichtbar ist, stiftet mehr Verwirrung als Nutzen -
      // und das Zurueckschreiben alter Werte wuerde die sichtbare Auswahl
      // unter dem Kunden austauschen. Gespeichert wird deshalb auch nichts.
      if (window.PAWS_AB === 'B') { standLoeschen(); return; }
      var versuche = 0;
      var timer = setInterval(function () {
        versuche++;
        var fertig = pawsStart();
        if (fertig || versuche > 60) clearInterval(timer);
      }, 400);
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
